import { ConfigContext, ConfigContextType } from 'context/config';
import { useContext } from 'react';

const useConfig = () => {
  const { config } = useContext(ConfigContext) as ConfigContextType;
  return config;
};

export default useConfig;
